import { useState, useEffect } from 'react';
import { useDebounce } from '../../../../utils/hooks/useDebounce';
import { useAuth } from '../../../../utils/Auth';
import styles from './RuleName.module.css';

export default function RuleName({schedule}) {

    const { dataDispatch } = useAuth();
    const [ name, setName ] = useState(schedule?.name || '');

    const debouncedName = useDebounce(name, 500);

    useEffect(() => {
        if (debouncedName !== schedule?.name) {
            dataDispatch({
                type: 'schedule',
                data: {
                    id: schedule.id,
                    name: debouncedName
                }
            });
        }
    },[debouncedName, schedule.id, schedule.name, dataDispatch])

    return (
        <div className={styles.inputGroup}>
            <label htmlFor='rule-nickname' className={styles.label}>Rule Name <span>(Optional)</span></label>
            <input type='text' id='rule-nickname' className={styles.input} maxLength='50' value={name} placeholder='Name will be ID if not specified.' onChange={e => setName(e.target.value)} />
        </div>
    );
};